import React, {createContext, useEffect, useState} from "react";
import useCourses from "../Consumers/useCourses";
import getUpNextItem from "../../Helper/getUpNextItem";

export const UpNextContext = createContext(undefined);

export const UpNextProvider = (props: any) => {
    const semesters = useCourses();
    const [upNextItem, setUpNextItem] = useState<any>();

    useEffect(() => {
        if (semesters) {
            // const item = getUpNextItem(semesters);
            // setUpNextItem(item);
        }
    }, );

    return (
        <UpNextContext.Provider value={upNextItem}>
            {props.children}
        </UpNextContext.Provider>
    );
};